import { SET_INCREMENT_PAGE, SET_DECREMENT_PAGE, SET_DEFAULT_PAGE } from "../Action/PaginateAction";

const initialState = {
  page: 1,
};

const PaginateReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_INCREMENT_PAGE:
      return { ...state, page: state.page + 1 };
    case SET_DECREMENT_PAGE:
      return { ...state, page: state.page - 1 };
    case SET_DEFAULT_PAGE:
      return { ...state, page: action.value };
    default:
      return state;
  }
};

export default PaginateReducer;
